import { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/macro";

const couponWarningsTranslation: Record<any, MessageDescriptor> = {
  ["The coupon is not applicable to your cart."]: msg`The coupon is not applicable to your cart.`,
};

export default couponWarningsTranslation;
